module.exports = __webpack_public_path__ + "img/Group 1422 (1).aaca126a.png";